// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".8b745d422894739f35637e8fb113597336d47c21.chunk.js";
};